import { FC } from 'react';
import { SkeletonLoader } from '@frontend/design-system';
import { countLoader } from './styles';

export const CountSkeletonLoader: FC = () => {
  return (
    <div css={countLoader}>
      <SkeletonLoader width={32} height={72} />
      <SkeletonLoader width={64} height={48} />
    </div>
  );
};
export const ListSkeletonLoader: FC = () => {
  return (
    <div
      css={{
        display: 'flex',
        flexDirection: 'column',
        gap: '8px',
        width: '100%',
        padding: '24px 24px 0px 24px',
      }}
    >
      <div css={{ gap: '8px', display: 'flex', flexDirection: 'row', width: '100%' }}>
        <SkeletonLoader width={24} height={24} />
        <SkeletonLoader width='80%' height={24} />
      </div>

      <div css={{ gap: '8px', display: 'flex', flexDirection: 'row', width: '100%' }}>
        <SkeletonLoader width={24} height={24} />
        <SkeletonLoader width='30%' height={24} />
        <SkeletonLoader width='30%' height={24} />
      </div>
    </div>
  );
};
